"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountRoleClient = void 0;
const tslib_1 = require("tslib");
const qs_1 = tslib_1.__importDefault(require("qs"));
const authenticated_client_1 = require("./authenticated.client");
class AccountRoleClient extends authenticated_client_1.AuthenticatedClient {
    find(accountId, request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/accounts/${accountId}/assignments`, {
                params: request,
                paramsSerializer: (params) => qs_1.default.stringify(params, { arrayFormat: 'comma' }),
            });
            return response.payload;
        });
    }
    promoteUsers(accountId, request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.httpPut(`/v1/accounts/${accountId}/users/admin`, request);
        });
    }
    demoteUsers(accountId, request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.httpDelete(`/v1/accounts/${accountId}/users/admin`, request);
        });
    }
    setEmployeeReferentRole(accountId, userId, roleId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.httpPut(`/v1/accounts/${accountId}/users/${userId}/role`, { roleId });
        });
    }
}
exports.AccountRoleClient = AccountRoleClient;
//# sourceMappingURL=account-role.client.js.map